import { render, staticRenderFns } from "./base_info.vue?vue&type=template&id=f5668664&scoped=true"
import script from "./base_info.vue?vue&type=script&lang=js"
export * from "./base_info.vue?vue&type=script&lang=js"
import style0 from "./base_info.vue?vue&type=style&index=0&id=f5668664&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5668664",
  null
  
)

export default component.exports